module.exports = __webpack_public_path__ + "img/MaskGroup 2887.d7a6319c.svg";